import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { getCookie } from 'redux/saga/helpers/cookies';
import { dashFeatureById } from 'redux/saga/entities/bound';
import { ANALYTICS_SEGMENT_ENABLED } from 'constants/analytics';
import { decorateWith, withName } from 'helpers/decorator';
import {
  setIsFlagLoaded as setIsFlagLoadedFn,
  setSegmentEnabled as setSegmentEnabledFn,
  segment,
} from 'helpers/segment';

export const SEGMENT_INIT = `!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.1.0";
    {onLoad}
  }}();`;

const trackPageView = () => {
  const pageProps = {
    path: window.location.pathname,
    search: window.location.search,
    url: window.location.href,
  };

  // We override both the page properties, and the context properties
  // as per instructions from a Segment rep:
  //
  // "
  // For Page calls, the page information is passed as both a property and in the context.
  // When overwriting this automatically collected information, you may want to set the same URL twice.
  // "
  segment.page(pageProps, { page: pageProps });
};

export class SegmentSDKUnwrapped extends Component {
  componentDidMount() {
    const { enableSegment, flagLoaded, setIsFlagLoaded, setSegmentEnabled } = this.props;

    setIsFlagLoaded(flagLoaded);
    setSegmentEnabled(enableSegment);

    const cpUserType = getCookie('cpUserType') || 'prospect';

    trackPageView();
    segment.identify({
      user_type: cpUserType,
    });
  }

  componentDidUpdate(prevProps) {
    const { currentPath, enableSegment, flagLoaded, setIsFlagLoaded, setSegmentEnabled, userId } = this.props;
    if (flagLoaded !== prevProps.flagLoaded) {
      setIsFlagLoaded(flagLoaded);
    }

    if (enableSegment !== prevProps.enableSegment) {
      setSegmentEnabled(enableSegment);
    }

    // Track a page view if the URL changes
    if (currentPath !== prevProps.currentPath) {
      trackPageView();
    }

    if (userId !== prevProps.userId && userId) {
      segment.identify(userId);
    }
  }

  render() {
    const { accountKey, enableSegment } = this.props;

    if (!enableSegment) {
      return null;
    }

    const accountInit = `analytics.load('${accountKey}')`;

    return (
      <Helmet>
        <link rel="dns-prefetch" href="//api.segment.io" />
        <link rel="preconnect" href="//api.segment.io" crossOrigin="anonymous" />
        <script key="segment-script">{SEGMENT_INIT.replace('{onLoad}', accountInit).replace(/\n/g, '')}</script>
      </Helmet>
    );
  }
}

SegmentSDKUnwrapped.propTypes = {
  accountKey: PropTypes.string.isRequired,
  currentPath: PropTypes.string.isRequired,
  deviceType: PropTypes.string.isRequired,
  enableSegment: PropTypes.bool,
  flagLoaded: PropTypes.bool,
  routes: PropTypes.array,
  msa: PropTypes.object,
  currentUser: PropTypes.object,
  setIsFlagLoaded: PropTypes.func.isRequired,
  setSegmentEnabled: PropTypes.func.isRequired,
  userId: PropTypes.number,
};

const mapStateToProps = state => {
  const isSegmentEnabled = dashFeatureById.data(state, ANALYTICS_SEGMENT_ENABLED);

  return {
    enableSegment: isSegmentEnabled,
    flagLoaded: dashFeatureById.loaded(state, ANALYTICS_SEGMENT_ENABLED),
    setIsFlagLoaded: setIsFlagLoadedFn,
    setSegmentEnabled: setSegmentEnabledFn,
  };
};

export const SegmentSDK = decorateWith(connect(mapStateToProps), withName('SegmentSDK'))(SegmentSDKUnwrapped);
